import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { Location } from '../../../app/models/Location';
import useLocationService from '../../../app/services/hooks/useLocationService';
import LocationFormContainer from './LocationFormContainer';

interface Props {
    locationId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const LocationEdit = ({ locationId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingEditLocation, editLocation, fetchingUpdateLocation, updateLocation } =
        useLocationService();

    const [location, setLocation] = useState<Location>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando ubicación...');
        editLocation(locationId, {
            onSuccess: (response: ServiceResponse) => {
                setLocation(response.data.location);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando ubicación...');
        updateLocation(locationId, location, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditLocation ? (
        <LazyLoading height="300" />
    ) : (
        <LocationFormContainer
            fetching={fetchingUpdateLocation}
            action={update}
            cancel={cancel}
            location={location}
            setLocation={setLocation}
            errorFields={errorFields}
        />
    );
};

export default LocationEdit;
